/* eslint-disable max-len */
import 'react';

const CloseSideSvg = () => {
    return (
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
                <rect id="path-1" x="0" y="0" width="20" height="20"></rect>
            </defs>
            <g id="知识库列表" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="部门详情首页" transform="translate(-215.000000, -98.000000)">
                    <g id="侧边栏" transform="translate(0.000000, 60.000000)">
                        <g id="icon_关闭侧边" transform="translate(215.000000, 38.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <g id="矩形"></g>
                            <g mask="url(#mask-2)">
                                <g transform="translate(10.000000, 10.000000) rotate(-315.000000) translate(-10.000000, -10.000000) translate(3.000000, 3.000000)">
                                    <rect id="矩形" opacity="0.300000012" x="0" y="0" width="14" height="14"></rect>
                                    <g id="编组-14备份" strokeWidth="1" fillRule="evenodd" transform="translate(2.000000, 2.000000)">
                                        <rect id="矩形" fill="#5C6473" x="0" y="5" width="11" height="1" rx="0.5"></rect>
                                        <rect id="矩形" fill="#5C6473" transform="translate(5.500000, 5.500000) rotate(-270.000000) translate(-5.500000, -5.500000) " x="1.13686838e-13" y="5" width="11" height="1" rx="0.5"></rect>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};


export default CloseSideSvg;
